/**
 * @file 相对时间文案组件
 */
import React from 'react';
import { useIntl } from 'umi';
import { useRelativeTime } from '@/pages/aigc/hooks/useRelativeTime';

export interface IRelativeTimeTextProps {
  /** ISO 更新时间；缺省时展示「最近一周」文案 */
  updatedAt?: string;
}

/** 相对时间文案 */
const RelativeTimeText: React.FC<IRelativeTimeTextProps> = ({ updatedAt }) => {
  const { formatMessage } = useIntl();
  const relativeTime = useRelativeTime(updatedAt || Date.now());
  return (
    <span>
      {updatedAt
        ? relativeTime
        : formatMessage({ id: 'dba_kb_time_recent_week' })}
    </span>
  );
};

export default RelativeTimeText;
